import { render } from "./MapsList.vue?vue&type=template&id=5f8d1e52"
import script from "./MapsList.vue?vue&type=script&lang=js"
export * from "./MapsList.vue?vue&type=script&lang=js"

import "./MapsList.vue?vue&type=style&index=0&id=5f8d1e52&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__